import { render, staticRenderFns } from "./OurBeliefs.vue?vue&type=template&id=5b8d4a15&scoped=true&"
import script from "./OurBeliefs.vue?vue&type=script&lang=js&"
export * from "./OurBeliefs.vue?vue&type=script&lang=js&"
import style0 from "./OurBeliefs.vue?vue&type=style&index=0&id=5b8d4a15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8d4a15",
  null
  
)

export default component.exports